import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import { actionOverlay } from '../../store/Overlay';
import { device, fixPoints } from '../../styles/variables';
import whiteLogo from '../../assets/images/logos/rd-logo-white.png';

const mediaQuery = `${device.laptop} and ${fixPoints.oneMax}`;

const StyledLogo = styled.div`
  pointer-events: all;
  box-sizing: border-box;
  padding: 23px 0 0 52px;
  margin: 0;
  max-width: 1169px;
  @media ${mediaQuery} {
    padding: 23px 0 0 118px;
  }

  @media ${fixPoints.oneMin} {
    margin: 0 auto;
  }
`;

const LogoImg = styled.img`
  height: 60px;
  width: 113px;
  cursor: pointer;
`;

class Logo extends React.PureComponent {
  goToRoute() {
    const { history, overlay, closeOverlay } = this.props;
    history.push('/');

    // need to close the overlay if it is open
    if (overlay.opened) closeOverlay({ opened: false, overlayType: overlay.overlayType });
  }

  render() {
    const { logo, alt, className } = this.props;

    return (
      <StyledLogo className={className}>
        <LogoImg src={logo} alt={alt} onClick={() => this.goToRoute()} />
      </StyledLogo>
    );
  }
}

Logo.defaultProps = {
  logo: whiteLogo,
  alt: 'Radical logo',
  overlay: {},
  className: ''
};

Logo.propTypes = {
  logo: PropTypes.string,
  alt: PropTypes.string,
  history: PropTypes.any.isRequired,
  overlay: PropTypes.object,
  closeOverlay: PropTypes.func.isRequired,
  className: PropTypes.string
};

const mapStateToProps = state => ({
  overlay: state.overlay
});

const mapDispatchToProps = dispatch => ({
  closeOverlay(overlayState) {
    dispatch(actionOverlay(overlayState));
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Logo)
);



// WEBPACK FOOTER //
// ./src/components/Logo/index.jsx